const handleCollapse = () => {
	$('.js-collapse').on('click', function(event) {
		const $this = $(this);
		const $targetElement = $($this.attr('href'));

		$this.toggleClass('is-current');

		$targetElement.slideToggle();

		event.preventDefault();
	});
}

handleCollapse();
